var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart2',{staticClass:"chart-canvas",attrs:{"chart-options":_vm.config.options,"chart-data":_vm.config.data}})}
var staticRenderFns = []

export { render, staticRenderFns }